
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/external-experts",
      function () {
        return require("private-next-pages/docs/external-experts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/external-experts"])
      });
    }
  